const breadcrumbPath = [
  {
    label: "Organismos",
    href: "./organism"
  }
];

export { breadcrumbPath };